var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OphthalmologyItem',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }